<!-- @if(st.getAccessToken()){ -->
<ng-content></ng-content>
<!-- } -->